import { createFileRoute, Navigate } from "@tanstack/react-router";

/** A workspace's home is its customers, the directory's first list. */
function WorkspaceHome() {
  return <Navigate to="/admin/customers" replace />;
}

export const Route = createFileRoute("/admin/")({ component: WorkspaceHome });
